const blogs = {
  seeMore: "Mehr anzeigen",
  blog: "Blog",
  create: "Blogbeitrag erstellen",
  edit: "Blogbeitrag bearbeiten",
  latest: "Neueste Beiträge",
  postsBlog: "Blogbeiträge",
  link: "Artikellink",
  preview: "Vorschau des Blogbeitrags",
  createBlogInstruction:
    "Der Blogbeitrag wird auf der Seite „In den Medien“ an erster Stelle angezeigt.",
  missingDataInLanguages: "Fehlende Daten in einer oder mehreren Sprachen.",
  emptyPage: "Auf dieser Seite sind keine Artikel vorhanden.",
  blogDetail: "Blogbeitrag-Details",
};

export default blogs;
